import { useCallback, useMemo } from 'react';
import {
	PERP_MARKETS_COLUMN_HEADERS_CONFIG,
	SPOT_MARKETS_COLUMN_HEADERS_CONFIG,
} from 'src/components/MarketSelector/MarketSelectorTable/consts';
import { MarketSelectorTableHeaderValue } from 'src/components/MarketSelector/MarketSelectorTable/types';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';

export default function useGetCellDisplayStatus(
	currentMarketIsPerp: boolean,
	marketIsPerp: boolean
) {
	const isMobileScreenSize = useIsMobileScreenSize();

	const filteredHeaders = useMemo(() => {
		const config = marketIsPerp
			? PERP_MARKETS_COLUMN_HEADERS_CONFIG
			: SPOT_MARKETS_COLUMN_HEADERS_CONFIG;

		return config.filter((header) => {
			const isMarketTypeMatch =
				header.showForMarketTypes === 'all' ||
				(currentMarketIsPerp
					? header.showForMarketTypes === 'perp-only'
					: header.showForMarketTypes === 'spot-only');

			const isBreakpointMatch =
				header.breakpoint === 'all' ||
				(isMobileScreenSize
					? header.breakpoint === 'mobile-only'
					: header.breakpoint === 'desktop-only');

			return isMarketTypeMatch && isBreakpointMatch;
		});
	}, [marketIsPerp, currentMarketIsPerp, isMobileScreenSize]);

	const getDisplayStatus = useCallback(
		(marketHeader: MarketSelectorTableHeaderValue) => {
			return filteredHeaders.some((header) => header.value === marketHeader);
		},
		[filteredHeaders]
	);

	return getDisplayStatus;
}
